import { useGetEnvVariablesQuery } from '../store/BaseApi';
import { Logger } from 'aspen-spruce';
import React, { useEffect } from 'react';
import { css } from '@/styled-system/css';
import { datadogRum } from '@datadog/browser-rum';
import { useFavicon } from '../hooks/useFavicon';

const containerClass = css({
  backgroundColor: 'bg.neutral',
  width: '100%',
  minHeight: '100vh',
  margin: 0,
  padding: 0,
  '& main': {
    margin: 'auto',
    padding: '16px 10px',
    paddingBottom: '93px',
    maxWidth: '720px',
  },
  md: {
    '& > main': {
      padding: '24px 10px',
      paddingBottom: '93px',
    },
  },
  lg: {
    '& > main': {
      padding: '32px 10px',
      paddingBottom: '93px',
    },
  },
});

interface ContainerProps {
  children: React.ReactNode;
}

const Container = ({ children }: ContainerProps): JSX.Element => {
  const { data, error: envVariablesError } = useGetEnvVariablesQuery();

  useFavicon();

  useEffect(() => {
    if (envVariablesError) {
      Logger.error('Environment variables fetch', envVariablesError);
    }
  }, [envVariablesError]);

  useEffect(() => {
    if (data && data.dataDog && data.dataDog.sessionSampleRate > 0) {
      try {
        datadogRum.init({ ...data.dataDog, allowedTracingUrls: [data.apiLocation] });
      } catch (error) {
        Logger.error('Datadog RUM init', error);
      }
    }
  }, [data]);

  return <div className={containerClass}>{data && children}</div>;
};

export default Container;
